import '../../sass/plugins/sell_smart_carousel.scss';

$(() => {
  const sellSmartCarousels = $('.sell-smart-carousel');

  const initializeSellSmartCarousels = (element) => {
    const sliderNavigation = $(element).find(
      '.sell-smart-carousel__navigation'
    );
    const sliderSection = $(element).find(
      '.sell-smart-carousel__sections-wrapper'
    );
    const nextArrow = $(element).find('.next');
    const prevArrow = $(element).find('.prev');

    sliderNavigation.slick({
      infinite: true,
      variableWidth: true,
      dots: true,
      appendDots: '.sell-smart-carousel__dots',
      mobileFirst: true,
      slidesToShow: 1,
      swipe: false,
      nextArrow,
      prevArrow,
      focusOnSelect: true,
      asNavFor: '.sell-smart-carousel__sections-wrapper',
    });

    sliderSection.slick({
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      fade: true,
      swipe: false,
      mobileFirst: true,
    });
  };

  sellSmartCarousels.each((_, element) =>
    initializeSellSmartCarousels(element)
  );
});
